import { useEffect, useRef, useState } from "react";
import { EMPTY, DAYS_ARR, NUMMTH_FULLCHARMTH_MAP, S3_DIRECTORY_PRODUCTION, S3_DIRECTORY_NONPRODUCTION, production } from "./constants";
import { S3CLOUD_CLOUDFRONT } from "./s3directories";

export const ParseJWT = (token) => {
    try {
        var base64Urlstr = token.split('.')[1];
        var base64 = base64Urlstr.replace('-', '+').replace('_', '/');
        return JSON.parse(window.atob(base64));
    }
    catch (e) { return null }
}
export const Retrieve_personal_info = () => {
    try {
        const rawToken = localStorage.getItem('token')
        var token = rawToken.substring(4, rawToken.length)
        const _id = ParseJWT(token).id
        var acct_type = ParseJWT(token).acct_type
        if (acct_type !== 'VENDOR' && acct_type !== 'USER') { acct_type = 'UNKNOWN'; token = 'NONE'; }
        else return { token: token, _id: _id, acct_type: acct_type, }
    }
    catch (e) { return { token: EMPTY, _id: EMPTY, acct_type: EMPTY } }
}

function get_bigrams(string) {
    var s = string.toLowerCase()
    var v = s.split('');
    for (var i = 0; i < v.length; i++) { v[i] = s.slice(i, i + 2); }
    return v;
}

export const str_similarity = (str1, str2) => {
    if (str1.length > 0 && str2.length > 0) {
        var pairs1 = get_bigrams(str1);
        var pairs2 = get_bigrams(str2);
        var union = pairs1.length + pairs2.length;
        var hits = 0;
        for (var x = 0; x < pairs1.length; x++) {
            for (var y = 0; y < pairs2.length; y++) {
                if (pairs1[x] === pairs2[y]) hits++;
            }
        }
        if (hits > 0) return ((2.0 * hits) / union);
    }
    return 0.0
}

export const shuffle = (array = []) => {
    var new_array = array
    for (let i = new_array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [new_array[i], new_array[j]] = [new_array[j], new_array[i]]
    }
    return new_array
}

export const importexscript = (src) => {
    const script = document.createElement("script");
    script.src = src
    script.async = true;
    script.onload = () => { }
    document.body.appendChild(script);
}


export const retrieveDateobj = (date) => { // dissect date obj string to mm dd yy
    var dtobj, mm, dd, yy
    dtobj = new Date(date)
    mm = dtobj.getMonth() + 1;
    dd = dtobj.getDate();
    yy = dtobj.getFullYear();

    var readable_date = dd + '/' + mm + '/' + yy
    var d = readable_date.split('/')[0]
    var m = NUMMTH_FULLCHARMTH_MAP[parseInt(readable_date.split('/')[1], 10) - 1]
    var y = readable_date.split('/')[2]

    return {
        date: readable_date,
        day: DAYS_ARR[new Date(date).getDay()],
        d,
        m,
        y
    }
}

export const iconwrapper = (icon, style) => {
    return <div id='icon-wrapper-shared' style={style}>
        {icon}
    </div>
}

export const getS3fullpath_withbucketname = (key, filename) => {
    if (key.length > 0) {
        return (production
            ? S3CLOUD_CLOUDFRONT + S3_DIRECTORY_PRODUCTION[key]
            : S3CLOUD_CLOUDFRONT + S3_DIRECTORY_NONPRODUCTION[key])
            + filename
    }
    else {
        return filename
    }
}

export const decryptHashed = (encryptedHash, key = 812931982398) => {

    function decrypt(data, key) {
        let decryptedData = "";
        for (let i = 0; i < data.length; i++) {
            decryptedData += String.fromCharCode(data.charCodeAt(i) ^ key);
        }
        return decryptedData;
    }

    // Decrypt the encrypted hash
    const decryptedHash = decrypt(encryptedHash, key);
    return decryptedHash
}


export const parseDToPoints = (d) => {
    if (!d) return [];

    const commandRegex = /[MLml][^MLml]*/g;
    const commands = d.match(commandRegex);
    if (!commands) return [];

    const points = [];
    let current = { x: 0, y: 0 };

    for (const cmd of commands) {
        const type = cmd[0];
        const coords = cmd.slice(1).trim().split(/[\s,]+/).map(Number);

        for (let i = 0; i < coords.length; i += 2) {
            const x = coords[i];
            const y = coords[i + 1];

            if (isNaN(x) || isNaN(y)) continue;

            let px, py;

            if (type === 'M' || type === 'L') {
                px = x;
                py = y;
            } else if (type === 'm' || type === 'l') {
                px = current.x + x;
                py = current.y + y;
            }

            current = { x: px, y: py };
            points.push(current);
        }
    }

    return points;
}


export const pathsToImage = (paths, size = 140) => {
    if (!paths?.length) return null;

    const canvas = document.createElement("canvas");
    canvas.width = size;
    canvas.height = size;
    const ctx = canvas.getContext("2d");

    // ---- 1. Compute bounding box of all points ----
    let minX = Infinity, minY = Infinity;
    let maxX = -Infinity, maxY = -Infinity;

    for (const path of paths) {
        for (const pt of path.points) {
            minX = Math.min(minX, pt.x);
            minY = Math.min(minY, pt.y);
            maxX = Math.max(maxX, pt.x);
            maxY = Math.max(maxY, pt.y);
        }
    }

    // Empty? Return blank image
    if (!isFinite(minX)) return null;

    const pad = 8; // padding prevents clipped edges
    const width = maxX - minX;
    const height = maxY - minY;

    // ---- 2. Compute scale so drawing fits inside square ----
    const scale = (size - pad * 2) / Math.max(width, height);

    // ---- 3. Center the drawing ----
    const offsetX = (size - width * scale) / 2;
    const offsetY = (size - height * scale) / 2;

    ctx.lineCap = "round";

    // ---- 4. Draw all paths scaled into the thumbnail ----
    for (const path of paths) {
        ctx.strokeStyle = path.color;
        ctx.lineWidth = 8 * scale; // scale stroke width correctly

        ctx.beginPath();
        const pts = path.points;

        ctx.moveTo(
            offsetX + (pts[0].x - minX) * scale,
            offsetY + (pts[0].y - minY) * scale
        );

        for (let i = 1; i < pts.length; i++) {
            ctx.lineTo(
                offsetX + (pts[i].x - minX) * scale,
                offsetY + (pts[i].y - minY) * scale
            );
        }
        ctx.stroke();
    }

    return canvas.toDataURL("image/png");
};

export const  pointsToPath=(points)=> {
    if (!points || points.length === 0) return "";
    const [first, ...rest] = points;
    return (
        `M ${first.x} ${first.y}` +
        rest.map(p => ` L ${p.x} ${p.y}`).join("")
    );
}

export const pixelateImage = (img, pixelSize = 8, returnCanvas = false) => {
    if (!img || !img.width || !img.height) return null;

    const width = img.width - (img.width % pixelSize);
    const height = img.height - (img.height % pixelSize);

    // Output canvas
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    canvas.width = width;
    canvas.height = height;
    ctx.imageSmoothingEnabled = false;

    // Small canvas
    const smallCanvas = document.createElement("canvas");
    const smallCtx = smallCanvas.getContext("2d");
    smallCanvas.width = width / pixelSize;
    smallCanvas.height = height / pixelSize;
    smallCtx.imageSmoothingEnabled = false;

    // Downscale → pixel version
    smallCtx.drawImage(img, 0, 0, smallCanvas.width, smallCanvas.height);

    // Upscale → crisp pixel blocks
    ctx.drawImage(
        smallCanvas,
        0, 0, smallCanvas.width, smallCanvas.height,
        0, 0, width, height
    );

    return returnCanvas ? canvas : canvas.toDataURL("image/png");
};


export const useInView=(options = {})=> {
  const { root = null, rootMargin = '0px', threshold = 0 } = options;
  const componentRef = useRef(null);
  const [isIntersecting, setIntersecting] = useState(false);
  
  // 1. New state: This tracks if the element has EVER been seen
  const [hasBeenViewed, setHasBeenViewed] = useState(false); 

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        // Update the current intersection status
        setIntersecting(entry.isIntersecting);
        
        // 2. STICKY LOGIC: If the element IS currently intersecting, 
        // set hasBeenViewed to true. It will never be set back to false.
        if (entry.isIntersecting) {
            setHasBeenViewed(true);
            
            // 3. OPTIMIZATION: Disconnect the observer once the element is viewed
            // This saves performance because we don't need to observe it anymore.
            observer.unobserve(entry.target);
            observer.disconnect();
        }
      },
      {
        root,
        rootMargin,
        threshold,
      }
    );

    const currentRef = componentRef.current;

    // Only start observing if we haven't already viewed it (prevents error if observer is already disconnected)
    if (currentRef && !hasBeenViewed) {
      observer.observe(currentRef);
    }

    // Cleanup function
    return () => {
      if (currentRef) {
        observer.disconnect();
      }
    };
  // We include hasBeenViewed in dependencies to handle the case where the observer disconnects
  }, [root, rootMargin, threshold, hasBeenViewed]); 

  // 4. Return the sticky state
  // We use hasBeenViewed as the main visibility indicator for animations
  return [hasBeenViewed, componentRef]; 
}

export default useInView;